export default "__VITE_ASSET__625884b8__"